import pagination from '../../utils/pagination'
import {
  CATEGORIES_BATCH_DELETE_REQUEST, CATEGORIES_BATCH_DELETE_SUCCESS, CATEGORIES_BATCH_DELETE_FAILURE,
  CATEGORIES_FETCH_MANY_REQUEST, CATEGORIES_FETCH_MANY_SUCCESS, CATEGORIES_FETCH_MANY_FAILURE,
  CATEGORIES_FETCH_ALL_REQUEST, CATEGORIES_FETCH_ALL_SUCCESS, CATEGORIES_FETCH_ALL_FAILURE,
  CATEGORIES_FETCH_REQUEST, CATEGORIES_FETCH_SUCCESS, CATEGORIES_FETCH_FAILURE,
  CATEGORIES_SAVE_REQUEST, CATEGORIES_SAVE_SUCCESS, CATEGORIES_SAVE_FAILURE,
  EMPTY_CATEGORIES,
  CLEAR_ERRORS
} from './types'

export default {
  [CATEGORIES_BATCH_DELETE_REQUEST] (state) {
    state.deleting = true
  },
  [CATEGORIES_BATCH_DELETE_SUCCESS] (state) {
    state.deleting = false
  },
  [CATEGORIES_BATCH_DELETE_FAILURE] (state) {
    state.deleting = false
  },
  [CATEGORIES_FETCH_MANY_REQUEST] (state) {
    state.data = []
    state.loading = true
  },
  [CATEGORIES_FETCH_MANY_SUCCESS] (state, { data }) {
    state.data = data.data
    state.page = pagination(data)
    state.loading = false
  },
  [CATEGORIES_FETCH_MANY_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.loading = false
  },
  [CATEGORIES_FETCH_ALL_REQUEST] (state) {
    state.data = []
    state.loading = true
  },
  [CATEGORIES_FETCH_ALL_SUCCESS] (state, { data }) {
    state.data = data
    state.loading = false
  },
  [CATEGORIES_FETCH_ALL_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.loading = false
  },
  [CATEGORIES_FETCH_REQUEST] (state) {
    state.single = {}
    state.loading = true
  },
  [CATEGORIES_FETCH_SUCCESS] (state, { data }) {
    state.single = data
    state.loading = false
  },
  [CATEGORIES_FETCH_FAILURE] (state) {
    state.loading = false
  },
  [CATEGORIES_SAVE_REQUEST] (state) {
    state.data = []
    state.saving = true
  },
  [CATEGORIES_SAVE_SUCCESS] (state) {
    state.saving = false
  },
  [CATEGORIES_SAVE_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.saving = false
  },
  [EMPTY_CATEGORIES] (state) {
    state.data = []
    state.loading = false
    state.saving = false
  },
  [CLEAR_ERRORS] (state) {
    state.validationErrors = []
    state.loading = false
    state.saving = false
  }
}
